import { VALIDATION_PATTERNS } from '@/config/constants'

export const validateEmail = (email: string): boolean => {
  return VALIDATION_PATTERNS.EMAIL.test(email)
}

export const validatePhone = (phone: string): boolean => {
  return VALIDATION_PATTERNS.PHONE.test(phone)
}

export const validateRequired = (value: string | undefined | null): boolean => {
  return value !== undefined && value !== null && value.trim().length > 0
}

export const validateMinLength = (value: string, minLength: number): boolean => {
  return value.trim().length >= minLength
}

export const validatePassword = (password: string): boolean => {
  // Must be at least 8 characters and match the pattern: at least one lowercase, one uppercase, one digit, one special character
  return password.length >= 8 && VALIDATION_PATTERNS.PASSWORD.test(password)
}

export const validateHexColor = (color: string): boolean => {
  return VALIDATION_PATTERNS.HEX_COLOR.test(color)
}

/** SIRET must be exactly 14 digits. */
export const validateSiret = (siret: string): boolean => {
  return /^\d{14}$/.test(siret.trim())
}

/** Basic IBAN check (spaces ignored): 2 letters, 2 digits, then 10-30 alphanumerics. */
export const validateIban = (iban: string): boolean => {
  const normalized = iban.replace(/\s/g, '')
  return /^[A-Za-z]{2}\d{2}[A-Za-z0-9]{10,30}$/.test(normalized)
}

/** Returns a valid #RRGGBB color for the picker, or the fallback. */
export const toPickerHexColor = (color: string, fallback = '#08b2b3'): string => {
  if (validateHexColor(color)) {
    return color.toLowerCase()
  }
  return fallback
}

export const normalizeHexColorInput = (value: string): string => {
  const trimmed = value.trim()
  if (!trimmed) return ''
  return trimmed.startsWith('#') ? trimmed : `#${trimmed}`
}

export const formatPhone = (phone: string): string => {
  // Remove all non-digit characters
  const digits = phone.replace(/\D/g, '')
  // Format as 06XXXXXXXX or 07XXXXXXXX
  if (digits.length === 10 && (digits.startsWith('06') || digits.startsWith('07'))) {
    return digits
  }
  return phone
}

export const formatEmail = (email: string): string => {
  return email.toLowerCase().trim()
}

export const formatName = (name: string): string => {
  return name
    .toLowerCase()
    .trim()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

